
import React from 'react';
import WaterAlarmsTable from './WaterAlarmsTable';
import { recentAlarms } from '@/data/water-analytics-data';

interface WaterAlarmsTabProps {
  onDeviceClick?: (device: typeof recentAlarms[0]) => void;
}

const WaterAlarmsTab = ({ onDeviceClick }: WaterAlarmsTabProps) => {
  return (
    <div className="space-y-6">
      <WaterAlarmsTable onDeviceClick={onDeviceClick} />
    </div>
  );
};

export default WaterAlarmsTab;
